import React, { useEffect, useState } from 'react';
import { ChartsDataDistribution, LimiaresParaOsGraficos } from '../../config/api/index.js';
import { getColorForLimiar, serieCampanhaColor, getPlotlyPlot, getAmostraTipos, getNomeLimiarSerieOuAmostraParaGraficoDeDistribuicao, getAxisType } from './ChartsUtils';
import ReactResizeDetector from 'react-resize-detector';

var state;
var jsx = null;
var data = [];
var limiares = [];

const BoxPlotly = (props) => {
    //Get localized reac-plotly plot
    const Plot = getPlotlyPlot();

    const [axisType, setAxisType] = useState([]);
    const [siz, setSiz] = useState({});
    const [forceupdate, setForceUpdate] = useState({});

    function setData(d) { data = d; }
    function setLimiares(l) { limiares = l; }

    const graph = (props) => {
        if (!state || forceupdate) {
            state = getNewPlot(props);
            setForceUpdate(false);
            jsx = null;
        }
        return getOldPlot(state);
    }

    function getNewPlot(props) {
        if (!data) return
        return (
            {
                data: [...data, ...limiares],
                layout: {
                    width: siz.width,
                    height: siz.height,
                    hovermode: 'y',
                    xaxis: { type: axisType },//xaxis: { type: 'log' },
                    yaxis: { showticklabels: false },
                    yaxis2: {
                        overlaying: 'y',
                        range: [0, data.length * 5]
                    },
                    showlegend: true,
                    legend: {
                        x: 1.02, y: 1,
                        bgcolor: '#eceeee'
                    },
                    margin: { l: 5, r: 10, b: 30, t: 10, pad: 4 }
                },
                config: {
                    locale: "pt-BR",
                    displaylogo: false,
                    displayModeBar: false,
                    modeBarButtonsToRemove: ['sendDataToCloud', 'hoverCompareCartesian', 'hoverClosestCartesian', 'lasso2d', 'select2d', 'autoScale2d']
                }
            }
        );
    }

    function getOldPlot(props) {
        if (!data || data.length === 0) return
        if (!jsx) {
            jsx = (
                <Plot
                    data={state.data}
                    layout={state.layout}
                    config={state.config}
                />
            );
        }
        return jsx;
    }

    useEffect(() => {
        (async () => {
            if (!props.parametroSerie || !props.tipoLimiarSelecionado) return
            let dat = [];
            const dt = await ChartsDataDistribution(props.parametroSerie.parametro, props.parametroSerie.seriesHabilitadas)
            setAxisType(getAxisType(dt));
            dt.series.forEach(element => {
                dat.push(
                    {
                        type: 'box',
                        x: element.data,
                        y: 'y',
                        name: element.nomeSerie + ((element.unidade === null) ? ' ' : (' - (' + element.unidade + ')')),
                        _name: element.nomeSerie,
                        marker: { color: serieCampanhaColor((element.nomeSerie)) },
                        seriesid: element.idSerie
                    }
                );
            });
            setData(dat);
            if (!props.tipoLimiarSelecionado) return
            const tipoLimiarIds = props.tipoLimiarSelecionado.map(limiar => limiar.id);
            const tipoAmostraIds = getAmostraTipos();
            //get valores de limiares selecionados do servidor
            const lims = await LimiaresParaOsGraficos(props.parametroSerie.parametro, tipoAmostraIds, tipoLimiarIds)
            //calculate starting and ending Y
            function getYs(el) {
                let ys = [];
                if ((data.length) && data.length !== 0) {
                    const eachHeight = 5;
                    let index = null;
                    if (el.serieAnalise !== undefined && el.serieAnalise !== null) {
                        for (let i = 0; i < data.length; i++) {
                            if (data[i]._name === el.serieAnalise.nome) index = i;
                        }
                        ys = [eachHeight * index, eachHeight * (index + 1)];
                    }
                    else ys = [1, eachHeight * 5];
                }
                return ys;
            }
            let limiars = [];
            //load elementes to put into layout.shapes
            lims.forEach(element => {
                const ys = getYs(element);
                limiars.push(
                    {
                        mode: 'lines',
                        type: 'scatter',
                        name: getNomeLimiarSerieOuAmostraParaGraficoDeDistribuicao(element),
                        //hovertemplate: '%{x}',//NOT WORKING
                        //hoverinfo: 'x+name',//NOT WORKING
                        x: [element.valor, element.valor],
                        y: ys,
                        yaxis: 'y2',
                        line: {
                            color: getColorForLimiar(element.tipo, element.superior),
                            width: 3,
                            dash: 'dot'
                        }
                    }
                );
            });
            setLimiares(limiars);
            setForceUpdate(true);
        })()
    }, [props.parametroSerie, props.tipoLimiarSelecionado])

    const onResize = (width, height) => {
        setSiz({ width: width, height: height });
        setForceUpdate(true);
    }

    return (
        <div style={{ position: "absolute", width: "98%", height: "94%" }}>
            {graph(props)}
            <ReactResizeDetector handleWidth handleHeight onResize={onResize} />
        </div>
    );

}

export default BoxPlotly;